import { createAsyncThunk, AnyAction } from '@reduxjs/toolkit';

import ConfigService from 'api/config/ConfigService';

import { setCountryBlacklist, setMaintenance } from './slice';

import { throttle } from 'utils';

import { checkUserCountry, findBlacklistCountry } from './helpers';

export const getUserGeolocation = createAsyncThunk(
  'config/getUserGeofencing',
  throttle(async (_: any, { dispatch, extra }: any) => {
    try {
      const configService = extra.configService as ConfigService;

      const fetchGeolocation = async () => {
        const { geolocation } = await configService.getUserGeolocation();
        const isForbiddenCountry = findBlacklistCountry(geolocation.country_code);
        dispatch(setCountryBlacklist(isForbiddenCountry));
      };

      checkUserCountry()
        .then(country => {
          if (typeof country === 'string') {
            const isForbiddenCountry = findBlacklistCountry(country);
            dispatch(setCountryBlacklist(isForbiddenCountry));
          }
        })
        .catch(() => {
          fetchGeolocation();
        });
    } catch (error) {
      console.log(error);
    }
  }, 200)
) as unknown as () => AnyAction;

export const getMaintenance = createAsyncThunk(
  'config/getMaintenanceMode',
  throttle(async (_: any, { dispatch, extra }: any) => {
    try {
      const configService = extra.configService as ConfigService;
      const { healthcheck } = await configService.getMaintenance();

      dispatch(setMaintenance(healthcheck));
    } catch (error) {
      console.log(error);
    }
  }, 200)
) as unknown as () => AnyAction;
